/**
 * WebApi
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ItemAttributeTypes = 'Group' | 'Requirement' | 'Question' | 'EClassRequirement' | 'EClassQuestion' | 'Optional' | 'Information' | 'Assessment';

export const ItemAttributeTypes = {
    Group: 'Group' as ItemAttributeTypes,
    Requirement: 'Requirement' as ItemAttributeTypes,
    Question: 'Question' as ItemAttributeTypes,
    EClassRequirement: 'EClassRequirement' as ItemAttributeTypes,
    EClassQuestion: 'EClassQuestion' as ItemAttributeTypes,
    Optional: 'Optional' as ItemAttributeTypes,
    Information: 'Information' as ItemAttributeTypes,
    Assessment: 'Assessment' as ItemAttributeTypes
};

